function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawDarkAlley = function UndrawDarkAlley(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1081.15 638.54",
    style: style
  }, props), React.createElement("path", {
    fill: "#65617d",
    d: "M25.58 609.63h1055.57v28.91H25.58z"
  }), React.createElement("path", {
    d: "M749.57 235.34a19.14 19.14 0 0 0 .16 2.29 19.14 19.14 0 0 1-.16-2.29zM759.05 250.95a17.36 17.36 0 0 1-3.76-2.65 17.36 17.36 0 0 0 3.76 2.65z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.1,
    fill: primaryColor
  }, React.createElement("rect", {
    x: 319.75,
    y: 19.36,
    width: 84.82,
    height: 38.73,
    rx: 9.92,
    ry: 9.92
  }), React.createElement("rect", {
    x: 404.57,
    y: 19.36,
    width: 84.82,
    height: 38.73,
    rx: 9.92,
    ry: 9.92
  }), React.createElement("rect", {
    x: 489.39,
    y: 19.36,
    width: 84.82,
    height: 38.73,
    rx: 9.92,
    ry: 9.92
  }), React.createElement("rect", {
    x: 574.2,
    y: 19.36,
    width: 84.82,
    height: 38.73,
    rx: 9.92,
    ry: 9.92
  }), React.createElement("rect", {
    x: 319.75,
    y: 55.95,
    width: 84.82,
    height: 38.73,
    rx: 9.92,
    ry: 9.92
  }), React.createElement("rect", {
    x: 404.57,
    y: 55.95,
    width: 84.82,
    height: 38.73,
    rx: 9.92,
    ry: 9.92
  }), React.createElement("rect", {
    x: 489.39,
    y: 55.95,
    width: 84.82,
    height: 38.73,
    rx: 9.92,
    ry: 9.92
  }), React.createElement("rect", {
    x: 574.2,
    y: 55.95,
    width: 84.82,
    height: 38.73,
    rx: 9.92,
    ry: 9.92
  }), React.createElement("rect", {
    x: 234.93,
    y: 92.43,
    width: 84.82,
    height: 38.73,
    rx: 11.8,
    ry: 11.8
  }), React.createElement("rect", {
    x: 404.57,
    y: 92.43,
    width: 84.82,
    height: 38.73,
    rx: 11.8,
    ry: 11.8
  }), React.createElement("rect", {
    x: 489.39,
    y: 92.43,
    width: 84.82,
    height: 38.73,
    rx: 11.8,
    ry: 11.8
  }), React.createElement("rect", {
    x: 574.2,
    y: 92.43,
    width: 84.82,
    height: 38.73,
    rx: 11.8,
    ry: 11.8
  }), React.createElement("rect", {
    x: 319.75,
    y: 129.01,
    width: 84.82,
    height: 38.73,
    rx: 11.8,
    ry: 11.8
  }), React.createElement("rect", {
    x: 404.57,
    y: 129.01,
    width: 84.82,
    height: 38.73,
    rx: 11.8,
    ry: 11.8
  }), React.createElement("rect", {
    x: 489.39,
    y: 129.01,
    width: 84.82,
    height: 38.73,
    rx: 11.8,
    ry: 11.8
  }), React.createElement("rect", {
    x: 234.93,
    y: 165.49,
    width: 84.82,
    height: 38.73,
    rx: 11.8,
    ry: 11.8
  }), React.createElement("rect", {
    x: 234.93,
    y: 275.14,
    width: 84.82,
    height: 38.73,
    rx: 11.8,
    ry: 11.8
  }), React.createElement("rect", {
    x: 404.57,
    y: 165.49,
    width: 84.82,
    height: 38.73,
    rx: 11.8,
    ry: 11.8
  }), React.createElement("rect", {
    x: 489.39,
    y: 165.49,
    width: 84.82,
    height: 38.73,
    rx: 11.8,
    ry: 11.8
  }), React.createElement("rect", {
    x: 574.2,
    y: 165.49,
    width: 84.82,
    height: 38.73,
    rx: 11.8,
    ry: 11.8
  }), React.createElement("rect", {
    x: 659.02,
    y: 55.95,
    width: 84.82,
    height: 38.73,
    rx: 11.8,
    ry: 11.8
  }), React.createElement("rect", {
    x: 659.02,
    y: 129.01,
    width: 84.82,
    height: 38.73,
    rx: 6.76,
    ry: 6.76
  }), React.createElement("rect", {
    x: 659.02,
    y: 165.49,
    width: 84.82,
    height: 38.73,
    rx: 6.76,
    ry: 6.76
  }), React.createElement("rect", {
    x: 319.75,
    y: 202.08,
    width: 84.82,
    height: 38.73,
    rx: 11.56,
    ry: 11.56
  }), React.createElement("rect", {
    x: 404.57,
    y: 202.08,
    width: 84.82,
    height: 38.73,
    rx: 11.56,
    ry: 11.56
  }), React.createElement("rect", {
    x: 489.39,
    y: 202.08,
    width: 84.82,
    height: 38.73,
    rx: 11.56,
    ry: 11.56
  }), React.createElement("rect", {
    x: 574.2,
    y: 202.08,
    width: 84.82,
    height: 38.73,
    rx: 11.56,
    ry: 11.56
  }), React.createElement("rect", {
    x: 234.93,
    y: 238.55,
    width: 84.82,
    height: 38.73,
    rx: 11.56,
    ry: 11.56
  }), React.createElement("rect", {
    x: 150.11,
    y: 238.55,
    width: 84.82,
    height: 38.73,
    rx: 11.56,
    ry: 11.56
  }), React.createElement("rect", {
    x: 129,
    width: 84.82,
    height: 38.73,
    rx: 11.56,
    ry: 11.56
  }), React.createElement("rect", {
    x: 77,
    y: 38.73,
    width: 84.82,
    height: 38.73,
    rx: 11.56,
    ry: 11.56
  }), React.createElement("rect", {
    y: 180.49,
    width: 84.82,
    height: 38.73,
    rx: 11.56,
    ry: 11.56
  }), React.createElement("rect", {
    x: 42.41,
    y: 219.18,
    width: 84.82,
    height: 38.73,
    rx: 11.56,
    ry: 11.56
  }), React.createElement("rect", {
    x: 319.75,
    y: 238.55,
    width: 84.82,
    height: 38.73,
    rx: 11.56,
    ry: 11.56
  }), React.createElement("rect", {
    x: 404.57,
    y: 238.55,
    width: 84.82,
    height: 38.73,
    rx: 11.56,
    ry: 11.56
  }), React.createElement("rect", {
    x: 489.39,
    y: 238.55,
    width: 84.82,
    height: 38.73,
    rx: 11.56,
    ry: 11.56
  }), React.createElement("rect", {
    x: 574.2,
    y: 238.55,
    width: 84.82,
    height: 38.73,
    rx: 11.56,
    ry: 11.56
  }), React.createElement("rect", {
    x: 404.57,
    y: 275.14,
    width: 84.82,
    height: 38.73,
    rx: 11.2,
    ry: 11.2
  }), React.createElement("rect", {
    x: 489.39,
    y: 275.14,
    width: 84.82,
    height: 38.73,
    rx: 11.2,
    ry: 11.2
  }), React.createElement("rect", {
    x: 234.93,
    y: 311.61,
    width: 84.82,
    height: 38.73,
    rx: 11.2,
    ry: 11.2
  }), React.createElement("rect", {
    x: 319.75,
    y: 311.61,
    width: 84.82,
    height: 38.73,
    rx: 11.2,
    ry: 11.2
  }), React.createElement("rect", {
    x: 319.75,
    y: 348.14,
    width: 84.82,
    height: 38.73,
    rx: 11.2,
    ry: 11.2
  }), React.createElement("rect", {
    x: 404.57,
    y: 311.61,
    width: 84.82,
    height: 38.73,
    rx: 11.2,
    ry: 11.2
  }), React.createElement("rect", {
    x: 489.39,
    y: 311.61,
    width: 84.82,
    height: 38.73,
    rx: 11.2,
    ry: 11.2
  }), React.createElement("rect", {
    x: 574.2,
    y: 311.61,
    width: 84.82,
    height: 38.73,
    rx: 11.2,
    ry: 11.2
  }), React.createElement("rect", {
    x: 404.57,
    y: 348.2,
    width: 84.82,
    height: 38.73,
    rx: 11.2,
    ry: 11.2
  }), React.createElement("rect", {
    x: 489.39,
    y: 348.2,
    width: 84.82,
    height: 38.73,
    rx: 11.2,
    ry: 11.2
  }), React.createElement("rect", {
    x: 234.93,
    y: 384.67,
    width: 84.82,
    height: 38.73,
    rx: 11.2,
    ry: 11.2
  }), React.createElement("rect", {
    x: 319.75,
    y: 384.67,
    width: 84.82,
    height: 38.73,
    rx: 11.2,
    ry: 11.2
  }), React.createElement("rect", {
    x: 404.57,
    y: 384.67,
    width: 84.82,
    height: 38.73,
    rx: 11.2,
    ry: 11.2
  }), React.createElement("rect", {
    x: 489.39,
    y: 384.67,
    width: 84.82,
    height: 38.73,
    rx: 11.2,
    ry: 11.2
  }), React.createElement("rect", {
    x: 574.2,
    y: 384.67,
    width: 84.82,
    height: 38.73,
    rx: 11.2,
    ry: 11.2
  }), React.createElement("rect", {
    x: 659.02,
    y: 384.67,
    width: 84.82,
    height: 38.73,
    rx: 6.76,
    ry: 6.76
  }), React.createElement("rect", {
    x: 319.75,
    y: 421.26,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 404.57,
    y: 421.26,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 489.39,
    y: 421.26,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 574.2,
    y: 421.26,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 319.75,
    y: 457.73,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 404.57,
    y: 457.73,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 489.39,
    y: 457.73,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 574.2,
    y: 457.73,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 234.93,
    y: 494.32,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 319.75,
    y: 494.32,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 404.57,
    y: 494.32,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 489.39,
    y: 494.32,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 574.2,
    y: 494.32,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 234.93,
    y: 530.79,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 319.75,
    y: 530.79,
    width: 84.82,
    height: 38.73,
    rx: 6.76,
    ry: 6.76
  }), React.createElement("rect", {
    x: 404.57,
    y: 530.79,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 489.39,
    y: 530.79,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 574.2,
    y: 530.79,
    width: 84.82,
    height: 38.73,
    rx: 6.59,
    ry: 6.59
  }), React.createElement("rect", {
    x: 234.93,
    y: 567.38,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 319.75,
    y: 567.38,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 404.57,
    y: 567.38,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 489.39,
    y: 567.38,
    width: 84.82,
    height: 38.73,
    rx: 6.59,
    ry: 6.59
  }), React.createElement("rect", {
    x: 574.2,
    y: 567.38,
    width: 84.82,
    height: 38.73,
    rx: 6.59,
    ry: 6.59
  }), React.createElement("rect", {
    x: 659.02,
    y: 494.32,
    width: 84.82,
    height: 38.73,
    rx: 8.15,
    ry: 8.15
  }), React.createElement("rect", {
    x: 659.02,
    y: 567.38,
    width: 84.82,
    height: 38.73,
    rx: 6.59,
    ry: 6.59
  })), React.createElement("path", {
    d: "M613.12 568.27a8.33 8.33 0 0 0-.77-.53s-1-11.44-7.23-18.51-7.4-26.59-7.4-26.59a14.86 14.86 0 0 0-2.34-.19c-.28-.61-.72-1.56-1.2-2.68-1-2.47-2.26-5.68-2.36-7.4-.16-3-7.4-19.35-7.4-19.35s-7.57-38.19-21.38-50.31c0 0-5.55-7.75-5.55-11.95s-6.39-6.06-6.39-6.06-4.22-12.28-3.87-15.65-9.26-14.65-9.26-14.65-1.27-11.44-3.74-14.29-2-10.63-2-10.63-7.23-6.71-6.56-11.09-2.19-11.62-2.19-11.62 5-8.83 5.6-16a14.32 14.32 0 0 0 0-2.7 8.66 8.66 0 0 0 3.15-1.11c5.05-4.22-1.17-43.44-1.17-43.44s-6.91-22-3.37-38.53-11.62-93.05-11.62-93.05-2.44-8.76-5.07-13.85c-.17-.32-.34-.62-.51-.91 1.91-1.4 2.55-4.61 2.55-4.61s7.25-10.09 3-13c-3.86-2.62-10.2-3.69-11.87-7.46a5.67 5.67 0 0 1-.24-.73c4.12.89 7.61 1.69 8.65 2.08 3 1.12 10.55 2.47 11.56-5s-13.91-25.91-15.26-26.59-3.59-6.28-3.59-6.28c1.57-2.92-2.69-6.28-2.69-6.28l-2.2 1.17c-.3-5.39-.94-11.49-.94-11.49s-1.69-3.82-4.72-16.83-9.42-7-11.66-7.3-14.7 1.69-19.41 2.81-25.47 16.27-27 16.6-7.18 10.77-7.86 13c-.24.8 1 1.73 2.62 2.59-.24.32-.47.64-.7 1a29 29 0 0 0 6.25 39c-.36.86-.72 1.73-1 2.62a14.37 14.37 0 0 0-.46 1.71 14.28 14.28 0 0 0-7.63 9.17c-1.42 5.27-2.81 12.23-1.11 14.71a11.39 11.39 0 0 1 2 7.92c.15.67 11.25 10.1 11.25 15.32s7.41-.85 8.76-2c.27-.24 1.59-1.23 3.55-2.64l-.82 1.94c-2.8 6.52-6.84 15.55-8.12 16.51-2 1.52-14.14 44.1-13.8 49.14s-1 32.66-1 32.66-4.21 39.36-7.4 44.43c0 0-2.2 18.67-4.22 19.17s-2.85 4.55 7.76 6.41c3.58.62 8.65 1.3 13.79 1.93l-1.43 2.51-17.92 31.4-15 35.84s-2.69 9.1-5.38 9.1-4.54 8.91-4.54 8.91-4.89 9.58-3.19 11.95 3.19 8.58 1 9.43-3.68 23-3.68 23l-12 42.92s-3.37 3-2.69 6.56-3.37 3.86-3.37 3.86a23.08 23.08 0 0 0-2.18 5c-.05.19-.07.37-.1.54a4.91 4.91 0 0 0-2.27 2.06c-4 6.91-10.1 21.2-13.62 22.89s-10.94 3.19-16.67 2.69-12.79 1.88-15.81.09a30.43 30.43 0 0 0-10.47-3c-3.54-.21-5.93 1-3.17 5.74 5.73 9.74 21.88 21.19 25.58 22.21s35.68 14.14 39.05 15.65 11.94 3 12.29 0-.85-9.77-.85-9.77a.23.23 0 0 0 0-.09c.61-1.21 6.67-13.54 6.2-16.91-.52-3.53 14.81-22.54 11.44-28.1 0 0 .21-1.07.47-2.52a51 51 0 0 0 .88-6.73c0-2.53 11.6-22.21 11.6-22.21s13.46-29.3 14-37.7 4.2-9.77 4.2-9.77.67-.68 1.68-4.54.17-10.6.17-10.6 5.71-4 5.89-6.57 38-51.32 38-51.32 2.53.5 3.7 4.88S514 450.05 514 450.05s14.64 4.2 15.66 13.78l6.06 10.61 11.76 21s3.72 11.12 8.43 14.65c0 0 3 6.06 1.85 8.91s4.53 5.06 4.53 5.06.93 4.53 1.36 7.57a15.34 15.34 0 0 1 .24 2.43 6.52 6.52 0 0 0-1.25 6.66c3.37 11.27 7.41 18.17 4 22s-12.11 14.64-12.11 14.64-13 3.88-15.84 5c-1.76.73-2.7 3.27-1.42 5.74a9 9 0 0 0 5.14 4c7.23 2.7 40.55 1.51 40.55 1.51s32-11.94 33.32-17.5c1.14-4.03-1.71-6.79-3.16-7.84z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M720.39 123.44a21.31 21.31 0 0 1-.11 2.4 28.82 28.82 0 1 1 .11-2.4z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M671.19 108.82c-.16 1.31.23 2.63.12 3.94-.15 1.71-1.13 3.2-1.87 4.74s-1.28 3.4-.52 4.93c.64 1.3 2 2 3 3.15 1.5 1.81 1.59 4.46.91 6.71-.48 1.61-1.29 3.41-.44 4.86.74 1.25 2.51 1.71 3 3.07a3.86 3.86 0 0 1-.26 2.62c-.76 2.05-1.77 4-2.44 6.08a10.58 10.58 0 0 0-.34 6.43 1.58 1.58 0 0 0 .39.72 1.8 1.8 0 0 0 1 .32l2.76.29c1.09.12 2.44.11 3-.85.26-.46.28-1.09.73-1.36s1.26.2 1.74.68a17.32 17.32 0 0 0 10.26 5 4.32 4.32 0 0 0 3-.46c.83-.58 1.24-1.62 2-2.21 1.84-1.36 4.57.17 6.7-.67 1.89-.75 2.6-3.06 2.68-5.1s-.19-4.17.69-6a26 26 0 0 1 2.57-3.44 11.37 11.37 0 0 0 1.65-8 29.37 29.37 0 0 0-2.5-7.91c-1.91-4.4-4.12-8.83-7.68-12a13.67 13.67 0 0 1-2.16-2.14c-1.62-2.28-1.19-5.62-3-7.75-1.45-1.72-3.92-2.13-6.17-2.09a22.2 22.2 0 0 0-9 2.06 11.25 11.25 0 0 1-2.7 1c-1.75.31-2.62-1.19-4.31-.44a4.87 4.87 0 0 0-2.81 3.82z",
    fill: "#464a5f"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M679.69 105.53a10.77 10.77 0 0 0 2.71-1 22.15 22.15 0 0 1 8.65-2h-1a22.2 22.2 0 0 0-9 2.06 12.22 12.22 0 0 1-2.53 1 2.84 2.84 0 0 0 1.17-.06zM677.85 156.68l-2.77-.29a1.77 1.77 0 0 1-1-.32 1.46 1.46 0 0 1-.39-.71 10.68 10.68 0 0 1 .33-6.44c.68-2.08 1.69-4 2.44-6.08a3.8 3.8 0 0 0 .26-2.62c-.51-1.36-2.28-1.82-3-3.07-.86-1.44 0-3.25.44-4.86.68-2.25.59-4.9-.91-6.71-.93-1.12-2.33-1.85-3-3.15-.76-1.53-.23-3.39.51-4.92s1.73-3 1.88-4.75c.11-1.31-.28-2.63-.12-3.94a4.84 4.84 0 0 1 2.84-3.73 2.44 2.44 0 0 1 .33-.1 2.28 2.28 0 0 0-1.67.1 4.87 4.87 0 0 0-2.85 3.73c-.16 1.31.23 2.63.12 3.94-.15 1.71-1.13 3.21-1.87 4.75s-1.28 3.39-.52 4.92c.64 1.3 2 2 3 3.15 1.5 1.81 1.59 4.46.91 6.71-.48 1.61-1.29 3.42-.44 4.86.74 1.25 2.51 1.71 3 3.07a3.86 3.86 0 0 1-.26 2.62c-.76 2.05-1.77 4-2.44 6.08a10.61 10.61 0 0 0-.34 6.44 1.55 1.55 0 0 0 .39.71 1.8 1.8 0 0 0 1 .32l2.76.29a6.39 6.39 0 0 0 1.45 0zM693.57 160.19a17.42 17.42 0 0 1-10.26-5c-.47-.48-1.16-1-1.74-.68a.62.62 0 0 0-.18.18 4.74 4.74 0 0 1 .58.5 17.39 17.39 0 0 0 10.26 5 6.83 6.83 0 0 0 1.63 0zM700.1 156.96a17.21 17.21 0 0 0 2.77.11 14.49 14.49 0 0 0-2.77-.11z"
  })), React.createElement("path", {
    d: "M832.42 559.58c-1.85 9.94-32.31 11.62-31.85 11.29a7.16 7.16 0 0 0-.17-2.7c-.43-3-1.36-7.56-1.36-7.56s-5.7-2.2-4.53-5.07-1.85-8.91-1.85-8.91c-4.71-3.53-8.42-14.65-8.42-14.65l-11.77-21-6.06-10.61c-1-9.58-15.66-13.78-15.66-13.78s-32.48-59.41-33.66-63.79-3.7-4.87-3.7-4.87-37.82 48.76-37.99 51.34-5.89 6.57-5.89 6.57.84 6.73-.17 10.59-1.68 4.54-1.68 4.54-3.71 1.35-4.2 9.77-14 37.7-14 37.7-11.6 19.68-11.6 22.22a51.16 51.16 0 0 1-.88 6.73c-.25 1.44-.47 2.52-.47 2.52s-28.94-10.83-31.12-11.64c-.75-.29-.79-1.27-.5-2.43a23.08 23.08 0 0 1 2.18-5s4-.32 3.37-3.86 2.69-6.56 2.69-6.56l12-42.92s1.5-22.21 3.69-23.05.67-7.08-1-9.42 3.19-12 3.19-12 1.84-8.91 4.54-8.91 5.38-9.1 5.38-9.1l15-35.84 17.92-31.4 3.79-6.63s75.4-6.74 84.65-2.36c3.11 1.47 3.9 4.71 3.58 8.36-.64 7.2-5.6 16-5.6 16s2.86 7.25 2.19 11.62 6.56 11.1 6.56 11.1-.5 7.75 2 10.62 3.74 14.3 3.74 14.3 9.59 11.28 9.26 14.65 3.87 15.64 3.87 15.64 6.39 1.86 6.39 6.06 5.55 12 5.55 12c13.74 12.13 21.31 50.33 21.31 50.33s7.24 16.33 7.4 19.34c.1 1.73 1.32 4.93 2.36 7.41.82 1.9 1.52 3.36 1.52 3.36z",
    fill: "#5f5d7e"
  }), React.createElement("path", {
    d: "M720.39 123.44a21.31 21.31 0 0 1-.11 2.4c-3.4 1.76-6.78 3.47-9.59 4.89-4 2-6.79 3.36-6.79 3.36s-14.7-9-17.39-13.13-11-10.43-11-10.43-2.08-.63-4.34-1.53a29.4 29.4 0 0 1-3.73-1.74 29 29 0 0 1 53 16.18z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M675.51 109.19s-10.66-3.26-10-5.5 6.28-12.68 7.85-13 22.33-15.49 27-16.61 17.16-3.14 19.41-2.8 8.64-5.72 11.67 7.29 4.71 16.83 4.71 16.83 1.79 16.94.78 19.3-33.09 18.06-33.09 18.06-14.7-9-17.39-13.13-10.94-10.44-10.94-10.44z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M765.82 367.18c-14.54 3.09-70.25 3.09-70.25 3.09s-11.32-1.13-21.79-2.45l3.79-6.63s75.4-6.74 84.65-2.36c3.13 1.44 3.92 4.7 3.6 8.35z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M768.97 363.37c-5 4.2-73.38 4.2-73.38 4.2s-23.56-2.36-34.15-4.2-9.78-5.9-7.76-6.41 4.22-19.17 4.22-19.17c3.19-5.06 7.4-44.43 7.4-44.43s1.35-27.6 1-32.66 11.78-47.62 13.8-49.14c1.28-1 5.32-10 8.12-16.51 1.61-3.78 2.83-6.7 2.83-6.7 8.57-15.48 50.81-19.2 54.17-17.18a8.69 8.69 0 0 1 2.51 3.34c2.64 5.09 5.07 13.84 5.07 13.84s15.15 76.56 11.62 93.06 3.37 38.53 3.37 38.53 6.23 39.22 1.18 43.43z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#5f5d7e",
    d: "M706.54 350.07h15.15v6.73h-15.15z"
  }), React.createElement("path", {
    d: "M683.48 362.69s-7.75 14-10.44 14.47-6.56 21.71 8.92 29 16-21.71 16-21.71l6.16-24.4-16.77-6.23z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M682.13 361.34s-7.74 14-10.43 14.48-6.57 21.71 8.92 28.94 16-21.71 16-21.71l6.15-24.4-16.76-6.23z",
    fill: "#464a5f"
  }), React.createElement("path", {
    d: "M747.26 423.44s12.12 13 18.68 7.24-18.68-7.24-18.68-7.24zM766.28 443.64s9.92 12.45 10.09 5.72-10.09-5.72-10.09-5.72zM776.37 473.27s7.07.5 9.6-3.2zM783.44 484.36s4.71 2.53 7.91-1.34zM697.95 393.99s3 17.17 15.48 23.9zM647.8 488.27s-1.52 4.38 6.9 5.56-6.9-5.56-6.9-5.56zM651.67 473.27s5.55 10.41 7.74 9.74zM658.74 464.12s1.68 4.76 5.89 4.26-5.89-4.26-5.89-4.26zM637 567.34c-.25 1.44-.47 2.52-.47 2.52s-28.96-10.78-31.14-11.59c-.75-.29-.79-1.27-.5-2.43 4.86-4.35 16.16 3.61 16.16 3.61s11.59 3.01 15.95 7.89z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M618.89 614.86a.39.39 0 0 1 0 .1s1.17 6.73.85 9.76-8.93 1.51-12.29 0-35.34-14.65-39-15.65-19.86-12.46-25.58-22.21c-2.76-4.73-.38-6 3.16-5.74a30.4 30.4 0 0 1 10.47 3c3 1.79 10.1-.6 15.81-.1s13.14-1 16.67-2.69 9.58-16 13.62-22.89 17.18 2.36 17.18 2.36 13.38 3.47 16.79 9.06-12 24.57-11.44 28.09-5.63 15.7-6.24 16.91z",
    fill: "#464a5f"
  }), React.createElement("path", {
    d: "M619.7 624.72c-.35 3-8.93 1.51-12.29 0s-35.34-14.65-39-15.65-19.86-12.46-25.58-22.21c-2.76-4.73-.38-6 3.16-5.74a24.54 24.54 0 0 0 8.62 10c9.93 7 31.47 16.88 31.47 16.88s12.12-.5 17.67 3c3.66 2.33 10.78 3.34 15.18 3.77a.39.39 0 0 1 0 .1s1.09 6.82.77 9.85z",
    fill: "#464a5f"
  }), React.createElement("path", {
    d: "M614.98 570.9s-11.95 22.68-11.95 24.2-4.71 15.65-4.71 15.65l8.33 3.37 3.12-18.18 11.1-21.88z",
    fill: "#464a5f"
  }), React.createElement("path", {
    d: "M832.42 559.58c-1.85 9.94-32.31 11.62-31.85 11.29a7.16 7.16 0 0 0-.17-2.7c4.03-4.9 15.17-4.9 15.17-4.9a22.75 22.75 0 0 1 15.33-7c.82 1.85 1.52 3.31 1.52 3.31z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M853.11 612.76c-1.34 5.56-33.32 17.5-33.32 17.5s-33.32 1.19-40.55-1.5a9.05 9.05 0 0 1-5.14-4c-1.28-2.46-.34-5 1.42-5.73 2.87-1.18 15.84-5.05 15.84-5.05s8.75-10.77 12.11-14.65-.67-10.77-4-22 16.1-11.34 16.1-11.34c8.75-8.92 18.85-6.91 18.85-6.91s1.17 19.53 7.4 26.59 7.23 18.52 7.23 18.52a6.92 6.92 0 0 1 .77.52c1.46 1.08 4.32 3.84 3.29 8.05z",
    fill: "#464a5f"
  }), React.createElement("path", {
    d: "M853.11 612.76c-1.34 5.56-33.32 17.5-33.32 17.5s-33.32 1.19-40.55-1.5a9.05 9.05 0 0 1-5.14-4c6.89 1.08 19.88 3 22 2.52 2.85-.67 14 .5 20.36-5.06s16-9.43 16-9.43 11.47-4.66 17.42-8c1.4 1 4.26 3.76 3.23 7.97z",
    fill: "#464a5f"
  }), React.createElement("path", {
    fill: "#464a5f",
    d: "M819.96 575.75l5.89 22.21 7.58 17.5 6.06-2.86-8.92-16.99-6.4-19.86h-4.21z"
  }), React.createElement("path", {
    d: "M620.87 574.06l-5.89-3.16s-11.95 22.68-11.95 24.2c0 1.2-3 10.37-4.19 14.09a54.12 54.12 0 0 0-12.8-1.14s-21.54-9.92-31.47-16.88a24.54 24.54 0 0 1-8.62-10c-3.54-.21-5.92 1-3.16 5.74 5.72 9.75 21.87 21.19 25.58 22.21s35.67 14.14 39 15.65 11.94 3 12.29 0-.85-9.76-.85-9.76a.39.39 0 0 0 0-.1 55.62 55.62 0 0 1-12-2.29l2.85-16.63zM849.84 604.71c-3.15 1.8-7.85 3.95-11.57 5.58l-7.7-14.69-6.39-19.85h-4.21l5.89 22.21 6.43 14.86c-1.17.49-9.9 4.2-15.85 9.37-6.4 5.56-17.51 4.39-20.36 5.06-2.09.48-15.08-1.44-22-2.52a9.05 9.05 0 0 0 5.14 4c7.23 2.69 40.55 1.5 40.55 1.5s32-11.94 33.32-17.5c1.05-4.18-1.81-6.94-3.25-8.02z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M696.04 139.03s14.92-17.61 19.64-20.42 23.67-12.9 23.67-12.9 4.26 3.37 2.69 6.28c0 0 2.25 5.61 3.59 6.29s16.27 19.07 15.26 26.59-8.53 6.17-11.56 5-26.47-5.72-26.47-5.72z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M718.82 126.92s10.21-3 11 0-11 0-11 0zM747.74 174.51a6.65 6.65 0 0 1-.65.54c-2 1.34-23.4 1.34-28.27 1.34-4.06 0-23.32 13.38-30.59 18.66 1.61-3.78 2.83-6.7 2.83-6.7 8.57-15.48 50.81-19.2 54.17-17.18a8.69 8.69 0 0 1 2.51 3.34z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M749.78 168.99s-.67 3.36-2.69 4.71-23.4 1.35-28.27 1.35-32 19.52-33.32 20.7-8.76 7.23-8.76 2-11.1-14.65-11.25-15.32a11.39 11.39 0 0 0-2-7.92c-1.7-2.48-.31-9.44 1.11-14.71a14.34 14.34 0 0 1 7.63-9.17c6.17-3 15.84-7.77 20.88-10.94 1.23-.79 3.29-1.11 5.89-1.12 13.56 0 41.62 8.87 41.62 8.87a5 5 0 0 0 .33 1.1c1.67 3.77 8 4.83 11.87 7.46 4.21 2.89-3.04 12.99-3.04 12.99z",
    fill: "#5f5d7e"
  }), React.createElement("path", {
    d: "M672.2 167.47s16.32.84 17.17 1.6-17.17-1.6-17.17-1.6zM716.97 184.98s-25.53 12.45-23.62 22.55c0 0 3.25 3.53 1.74 7.4s-2.86 31.13-1 33.15 3.87 6.9 2.86 10.27 1.51 18.51 1.51 18.51 3.71 7.57-.67 9.26-.5 7.23-.5 7.23 0 6.9-4.1 7.24-.78 9.09-.78 9.09-2 5.89-5.22 5.38 1.85 8.42 1.85 8.42-12.29 8.24-10.77 21.88l-1.7 9.25 24.23 10.44 3.2-6.06s6.56-1.52 5.72-5.56 4.38-6.39 4.38-6.39 1-6.23 4.37-8.92 8.58-14.14 8.58-14.14 3-6.39 7.24-9.08 7.57-15.82 7.57-15.82l2.53-90.38s-9.25-27.76-27.42-23.72z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M722.35 184.98s-25.52 12.45-23.62 22.55c0 0 3.26 3.53 1.74 7.4s-2.86 31.13-1 33.15 3.87 6.9 2.86 10.27 1.52 18.51 1.52 18.51 3.7 7.57-.67 9.26-.51 7.23-.51 7.23.06 6.9-4.09 7.24-.79 9.09-.79 9.09-2 5.89-5.22 5.38 1.86 8.42 1.86 8.42-12.29 8.24-10.78 21.88l-1.68 9.25 24.24 10.44 3.19-6.06s6.57-1.52 5.72-5.56 4.38-6.39 4.38-6.39 1-6.23 4.38-8.92 8.58-14.14 8.58-14.14 3-6.39 7.24-9.08 7.57-15.82 7.57-15.82l2.52-90.38s-9.22-27.76-27.44-23.72z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M719.66 184.98s-25.53 12.45-23.62 22.55c0 0 3.26 3.53 1.74 7.4s-2.86 31.13-1 33.15 3.87 6.9 2.86 10.27 1.52 18.51 1.52 18.51 3.7 7.57-.68 9.26-.5 7.23-.5 7.23.05 6.9-4.1 7.24-.78 9.09-.78 9.09-2 5.89-5.22 5.38 1.85 8.42 1.85 8.42-12.28 8.24-10.77 21.88l-1.68 9.25 24.23 10.44 3.2-6.06s6.56-1.52 5.72-5.56 4.38-6.39 4.38-6.39 1-6.23 4.37-8.92 8.59-14.14 8.59-14.14 3-6.39 7.23-9.08 7.57-15.82 7.57-15.82l2.52-90.38s-9.26-27.76-27.43-23.72z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M701.99 299.27s6.9 6.57 6.9 8.42-9.09-3.37-9.09-3.37zM697.95 315.4s6.73 7.57 4.54 7.91-4.54-7.91-4.54-7.91zM708.89 339.13s-15.32 2.52-11.78 3.53 11.78-3.53 11.78-3.53zM713.18 289.15s27.68 12.45 23 15.82-23-15.82-23-15.82zM740.92 148.56c-.66-.51-44.88-9.53-44.88-9.53l2.93-.44c13.56 0 41.62 8.87 41.62 8.87a5 5 0 0 0 .33 1.1zM709.39 83.94s13.24 17.45 19.52 13-9.87-14.34-19.52-13zM679.27 185.82s11.23-3.37 12.18-4-12.18 4-12.18 4zM731.84 168.9s11.69 1 12.81.69-12.81-.69-12.81-.69zM737.96 156.87s11.68 1 12.81.68-12.81-.68-12.81-.68zM705.25 156.13s11.68 1 12.81.69-12.81-.69-12.81-.69zM676.57 179.79s11.22-3.37 12.17-4-12.17 4-12.17 4z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M1061.77 475.97l-7.61 121.8a17.94 17.94 0 0 1-17.88 16.8h-91.71a17.94 17.94 0 0 1-17.88-16.8l-7.61-121.8a4.48 4.48 0 0 1 4.49-4.7h133.81a4.48 4.48 0 0 1 4.44 4.74z",
    fill: "#464a5f"
  }), React.createElement("path", {
    d: "M974.57 468.56c2.33.93 6.36 2.69 6.36-.62 0-1.39-1.14-1.5-2.22-1.86a19.81 19.81 0 0 1-9.87-7.85c-4.24-6.26-5.22-12.51-5.22-20 0-16.58 22.84-19.58 22.84-36.17 0-6.35-4-8.21-4-10 0-1.14.36-1.14 1.5-1.14 4.13 0 9.87 6.88 11.62 10.24a10 10 0 0 1 1.24 5.73c0 3.62-.36 7.34-.36 11 0 13.95 16.48 10.23 16.48 3.51 0-3.1-1.86-6-1.86-9 0-.36 0-.62.37-.62 1.75 0 4.85 4 5.73 5.22 3 4.6 4.39 10.75 4.39 16.22 0 16.74-15.24 25.32-15.24 28.94 0 .51 1.5 4 6.25 1 15.35-7.8 27.44-24.6 27.44-46.4 0-17.36-4.5-29.81-16.59-42.68-2-2.12-8.47-8.73-11.62-8.73-4.24 0 3.72 9.61 3.72 16.12a6 6 0 0 1-6.36 6.35c-6 0-7.49-13.12-8.21-17.2-3-17.47-6.62-30.07-24-38.29-5.37-2.58-18.86-6.1-18.86-1.13 0 1.24 1.4 2.11 2.38 2.63 4.75 2.89 10.13 11.06 10.13 19.74 0 23.82-29.82 45.57-29.82 70.37-.1 20.82 14.52 37.51 33.74 44.54z",
    fill: primaryColor
  }));
};
UndrawDarkAlley.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawDarkAlley;